<div class="google-auth-wrapper mb-3">
  <div #gbuttonWrapper>
    <div #gbutton></div>
  </div>
  <ng-container *ngIf="showErrorMessage | async">

  <p  class="funnel-form-footnote funnel-form-legal-text text-center">
    Sign in with Google is temporarily unavailable. It might be blocked by an adblocker or by browser privacy settings.
    <br />
    Please log in with your email and password. If you do not remember your password, please use the
    <a
      routerLink="/forgot-password"
      floAnalytics
      name="Forgot Password"
      class="link-forgot-password primary-color-text"
    >Forgot Password</a
    >
    feature using your Google account email address.
  </p>
  </ng-container>
</div>
